const ACCESSIBILITY_KEYS = new Set(['role', 'lang']);
const ACCESSIBILITY_PREFIXES = ['aria-'];
export const pickA11yProps = (props) => {
    const result = {};
    for (const key in props) {
        if (ACCESSIBILITY_KEYS.has(key) ||
            ACCESSIBILITY_PREFIXES.some((prefix) => key.startsWith(prefix))) {
            result[key] = props[key];
        }
    }
    return result;
};
//# sourceMappingURL=pick-a11y-props.js.map